import moment from "moment";

export const getFormattedDate = dateString => {
  let momentObj = moment.utc(dateString);
  return momentObj.format("DD-MM-YYYY HH:mm:ss");
};

export const getCountryFromHOFilmCode = HOFilmCode => {
  if (!HOFilmCode) return "";

  if (HOFilmCode.includes("KSA")) return "KSA";
  else if (HOFilmCode.includes("UAE")) return "UAE";
  else if (HOFilmCode.includes("OM")) return "Oman";
  else if (HOFilmCode.includes("")) return "Bahrain";
  else return "Unknown";
};
